module.exports = __webpack_public_path__ + "static/img/mdm_register2.ec674e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tip/mdm_register2.jpg
// module id = OO2G
// module chunks = 53